import { GraphQLResult } from "@aws-amplify/api-graphql";
import { API, graphqlOperation } from "aws-amplify";
import {
  CreateOrderInput,
  CreateOrderMutation,
  CreateStripePaymentIntentInput,
  CreateStripePaymentIntentMutation,
  Order,
  PaymentIntentCustomerInput,
  PaymentIntentOrderInput,
} from "../../API";
import {
  createOrder,
  createStripePaymentIntent,
} from "../../graphql/mutations";

export type CreateStripePaymentIntentMutationResult = {
  stripe_customer_id: string;
  payment_intent_id: string;
  clientSecret: string;
};
export const PaymentRepository = () => {
  const create = (order: Order) => {
    return new Promise<CreateStripePaymentIntentMutationResult>(async (res) => {
      const result = (await API.graphql(
        graphqlOperation(createStripePaymentIntent, {
          input: {
            order: {
              name: order.name,
              amount: order.total,
            } as PaymentIntentOrderInput,
            customer: {
              name: order.customer.name,
              email: order.customer.email,
              phone: order.customer.phone,
              stripe_customer_id: order.customer.stripeCustomerId || "",
            } as PaymentIntentCustomerInput,
          } as CreateStripePaymentIntentInput,
        })
      )) as GraphQLResult<CreateStripePaymentIntentMutation>;
      res(
        JSON.parse(
          result.data?.createStripePaymentIntent!
        ) as CreateStripePaymentIntentMutationResult
      );
    });
  };

  return {
    create,
  };
};
